import React from 'react';
import { KeyValueView, CustomModal, Loader } from 'commons-ui';

import useUserProfileActions from 'pages/userProfile/useUserProfileActions';
import { ACTION, PAGE_NAMES, RESOURCES } from 'constant';
import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { getKeyConfig } from './keyConfig';
import GameplayTimelineList from './list';
import OpponentGameDetails from './opponentDetails';
import AnalyzeCollusion from './analyzeCollusion';
import RefundSuggestion from './refundSuggestion';
import useTournamentDetails from './useTournamentDetails';
import { makeActionHandler, makeActionList } from './actions';
import { SHOW_OPPONENTS_GAME_DETAILS_GAME_LIST } from './constants';

const TournamentDetails: React.FC<{}> = () => {
	const { ltid, mttid, cgrid, gameName, playingAttempt, gameType, pwfInviteId } = useTournamentDetails();
	const { hasPermission: hasPermissionV2 } = usePermissionV2();
	const IsAnalyzeCollusionAccessible = hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: RESOURCES.gameplay,
		configActionName: ACTION.analyzeTournament
	});
	const IsRefundSuggestionAccessible = hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: RESOURCES.gameplay,
		configActionName: ACTION.refundSuggestion
	});
	const {
		keyConfig,
		tournamentStartTime,
		keyValueLayout,
		forceUpdateChild,
		turnGlobalForceUpdateOn,
		getGameplayTimelineData,
		showLoader,
		tableId,
		gameEndTime,
		gameStartTime,
		gameUid,
		registeredOn,
		tournamentStartTimeInMS,
		tournamentEndTimeInMS,
		registeredOnInMS,
		entryFee,
		transactionId,
		winnings,
		score,
		resultData,
		inning
	} = getKeyConfig({
		ltid,
		mttid,
		cgrid,
		gameName,
		playingAttempt,
		gameType,
		pwfInviteId
	});
	const { getActionHandler, getActionList } = useUserProfileActions(makeActionHandler, makeActionList, {
		ltid,
		mttid,
		cgrid,
		turnGlobalForceUpdateOn
	});

	return (
		<>
			{showLoader && <Loader />}
			<KeyValueView
				keyConfig={keyConfig}
				forceUpdate={forceUpdateChild}
				keyValueLayout={keyValueLayout}
				getActionHandler={getActionHandler}
				getActionList={getActionList}
			/>
			{IsRefundSuggestionAccessible && (
				<RefundSuggestion
					transactionId={transactionId}
					tournamentStartTimeInMS={tournamentStartTimeInMS}
					entryFee={entryFee}
					playingAttempt={playingAttempt}
					ltid={ltid}
					gameName={gameName}
					tableId={tableId}
					gameStartTime={gameStartTime}
					gameEndTime={gameEndTime}
					gameUid={gameUid}
					registeredOn={registeredOn}
					winnings={winnings}
					score={score}
					resultData={resultData}
					inning={inning}
				/>
			)}

			{forceUpdateChild && (
				<GameplayTimelineList
					getGameplayTimelineData={getGameplayTimelineData}
					tournamentDetails={{
						tableId,
						tournamentStartTimeInMS,
						tournamentEndTimeInMS,
						registeredOnInMS,
						gameUid,
						ltid,
						gameName,
						entryFee,
						playingAttempt,
						transactionId,
						gameType
					}}
					gameName={gameName}
				/>
			)}

			{forceUpdateChild && SHOW_OPPONENTS_GAME_DETAILS_GAME_LIST.includes(gameName as string) && (
				<OpponentGameDetails
					tournamentDetails={{
						tableId,
						tournamentStartTimeInMS,
						tournamentEndTimeInMS,
						registeredOnInMS,
						gameUid,
						ltid,
						gameName,
						entryFee,
						playingAttempt,
						transactionId,
						gameType
					}}
					gameName={gameName}
				/>
			)}
			{IsAnalyzeCollusionAccessible && (
				<AnalyzeCollusion ltid={ltid} tournamentStartTime={tournamentStartTime} gameName={gameName} tableId={tableId} />
			)}
			<CustomModal />
		</>
	);
};

export default TournamentDetails;
